import { useEffect } from 'react';
import { useTheme } from '@deephaven/components';
import MonacoUtils from "./MonacoUtils.js";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function MonacoThemeProvider(_ref) {
  var children = _ref.children;
  var _useTheme = useTheme(),
    activeThemes = _useTheme.activeThemes;
  useEffect(function refreshMonacoTheme() {
    if (activeThemes != null) {
      MonacoUtils.initTheme();
    }
  }, [activeThemes]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}
//# sourceMappingURL=MonacoThemeProvider.js.map